module.exports = __webpack_public_path__ + "img/game-board.074b7cbc.svg";